import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import DatePicker, {PickerMode} from './DatePicker'
import Input from '#components/a/form/Input'
import {format} from 'ag-common/facades'
import FlyoutAnchor from './Flyout/FlyoutAnchor'
import {FlyoutPivot} from './Flyout/FlyoutPivot'
import {FlyoutPosition} from './Flyout/FlyoutPosition'

const DateRangePicker = ({initialStartDate, initialEndDate, onRangeUpdated}) => {
  const [startDate, setStartDate] = useState(initialStartDate)
  const [endDate, setEndDate] = useState(initialEndDate)
  const [startPickerOpen, setStartPickerOpen] = useState(false)
  const [endPickerOpen, setEndPickerOpen] = useState(false)

  useEffect(() => {
    setStartDate(initialStartDate)
  }, [initialStartDate])

  useEffect(() => {
    setEndDate(initialEndDate)
  }, [initialEndDate])

  const onDatesUpdated = (start, end) => {
    const newStart = start
    const newEnd = end
    setStartDate(newStart)
    setEndDate(newEnd)
    onRangeUpdated(newStart, newEnd)
    hideDatePickers()
  }

  const renderStartPicker = () => {
    return (
      <DatePicker
        className="date-picker"
        startMonth={startDate}
        initialSelectedStart={startDate}
        initialSelectedEnd={endDate}
        pickerMode={PickerMode.start}
        onRangeChanged={onDatesUpdated}
      />
    )
  }

  const renderEndPicker = () => {
    return (
      <DatePicker
        className="date-picker"
        startMonth={endDate}
        initialSelectedStart={startDate}
        initialSelectedEnd={endDate}
        pickerMode={PickerMode.end}
        onRangeChanged={onDatesUpdated}
      />
    )
  }

  const hideDatePickers = () => {
    setStartPickerOpen(false)
    setEndPickerOpen(false)
  }

  const startPickerVisibilityChanged = visible => {
    setStartPickerOpen(visible)
  }

  const endPickerVisibilityChanged = visible => {
    setEndPickerOpen(visible)
  }

  const startText = format(startDate, 'dd.MM.yy')
  const endText = format(endDate, 'dd.MM.yy')

  return (
    <div className="terminDateRange">
      <div className="item">
        <span>{i18n.t('termin_from')}</span>
        <div className="inputStartDateWrapper">
          <FlyoutAnchor
            flyoutPosition={FlyoutPosition.bottom}
            flyoutPivot={FlyoutPivot.start}
            openSync={startPickerOpen}
            flyoutVisibilityChanged={startPickerVisibilityChanged}
            boundingElementClass="termin-edit-bounds"
            flyoutContent={renderStartPicker()}>
            <Input type="text" required isReadonly defaultValue={startText} key={startText} />
          </FlyoutAnchor>
        </div>
      </div>
      <div className="item">
        <span>{i18n.t('termin_to')}</span>
        <div className="inputEndDateWrapper">
          <FlyoutAnchor
            flyoutPosition={FlyoutPosition.bottom}
            flyoutPivot={FlyoutPivot.end}
            openSync={endPickerOpen}
            flyoutVisibilityChanged={endPickerVisibilityChanged}
            boundingElementClass="termin-edit-bounds"
            flyoutContent={renderEndPicker()}>
            <Input type="text" required isReadonly defaultValue={endText} key={endText} />
          </FlyoutAnchor>
        </div>
      </div>
    </div>
  )
}

export default DateRangePicker

DateRangePicker.propTypes = {
  initialStartDate: PropTypes.instanceOf(Date),
  initialEndDate: PropTypes.instanceOf(Date),
  onRangeUpdated: PropTypes.func,
}
